export default () => {
  const links = document.getElementsByTagName('a')
  if (document.body.clientWidth > 680) {
    ;[...links].forEach(link => {
      if (link.href.indexOf('tel:') !== -1) {
        link.addEventListener('click', e => {
          e.preventDefault()
          window.location = '/contact'
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/PhoneLink.js